<template>

    <div class="busca" :class='state'>
        <div class="input-group">
             <span class="input-group-addon"><i class='fa fa-search'></i></span>
             <input :placeholder="placeholder" v-model="palavra" class="form-control" type="search" @input="change" @change="change" @focus="state='focus'" @blur="state=''">
             <span class="input-group-addon"><i v-if="palavra!=''" id="limpa" @click="limpa" class='fa fa-times'></i> </span>
        </div>
    </div>

</template>




<script>

    import Vue from 'vue';

     export default {
        name: 'busca',
        
        data () {
            return {
                palavra:'',
                state:''
            }
        },

        props:{
            placeholder:{
                type:String,
                default:'Buscar'
            }
        },

        computed:{

        },

        methods:{

            change:function(ev){
                        var filtroWord = _.trim(ev.currentTarget.value);
                        this.palavra = filtroWord;
                        clearTimeout( this.filtrando )
                        this.filtrando =  setTimeout( ()=>this.$emit('change',this.palavra ),300 )
           
           },

           limpa:function(){
                this.palavra = "";
                this.$emit('change','')
           }

        }
     }

</script>


<style lang="stylus" >
    
    @import "../css/variaveis";


    .busca{
        
        // width:100px;

        .input-group-addon{
            opacity:0.5;
        }

        ::-webkit-input-placeholder { 
            font-size:1.2rem;
            color:rgba(black,0.2);
        }

        input{
                border:none !important;
                box-shadow: initial !important;
                font-size:1.2rem;
                background:none;
                color:cor-azul !important;
                font-weight:600 !important;
                &:focus{
                    
                }
        }

        &:hover,&.focus{
            background:rgba(cor-azul,0.4);
        }
    }

</style>